export const ACTUALIZAR_LIST_NIVEL3 = "ACTUALIZAR_LIST_NIVEL3";
export const MODIFICAR_NIVEL3 = "MODIFICAR_NIVEL3";
export const AGREGAR_NIVEL3 = "AGREGAR_NIVEL3";  
export const ELIMINAR_NIVEL3 = "ELIMINAR_NIVEL3";